var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_452_4662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5332 11.0977C3.7082 11.0977 3.0332 11.7727 3.0332 12.5977C3.0332 13.4227 3.7082 14.0977 4.5332 14.0977C5.3582 14.0977 6.0332 13.4227 6.0332 12.5977C6.0332 11.7727 5.3582 11.0977 4.5332 11.0977ZM19.5332 11.0977C18.7082 11.0977 18.0332 11.7727 18.0332 12.5977C18.0332 13.4227 18.7082 14.0977 19.5332 14.0977C20.3582 14.0977 21.0332 13.4227 21.0332 12.5977C21.0332 11.7727 20.3582 11.0977 19.5332 11.0977ZM12.0332 11.0977C11.2082 11.0977 10.5332 11.7727 10.5332 12.5977C10.5332 13.4227 11.2082 14.0977 12.0332 14.0977C12.8582 14.0977 13.5332 13.4227 13.5332 12.5977C13.5332 11.7727 12.8582 11.0977 12.0332 11.0977Z",
    fill: "#4A4A4B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_452_4662"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.0332031 0.597656)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDots);
export default __webpack_public_path__ + "static/media/icon-dots.dda4f840b8547f07494fb9bb4cd182ed.svg";
export { ForwardRef as ReactComponent };